module.exports = __webpack_public_path__ + "static/img/QRCode.15ffadd4.png";